import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';


const MINUTES_UNITL_AUTO_LOGOUT = 30 // in mins
const CHECK_INTERVAL = 1000 // in ms
const STORE_KEY =  'lastAction';

@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {

  get lastAction() {
    return parseInt(localStorage.getItem(STORE_KEY));
  }

 set lastAction(value) {
    localStorage.setItem(STORE_KEY, value.toString());
  }

  constructor(private authService: AuthService) {

    this.check();
    this.initListener();
    this.initInterval();
    localStorage.setItem(STORE_KEY,Date.now().toString());


   }

   initListener() {
    document.body.addEventListener('click', () => this.reset());
    // document.body.addEventListener('mouseover',()=> this.reset());
    // document.body.addEventListener('mouseout',() => this.reset());
    document.body.addEventListener('keydown',() => this.reset());
    document.body.addEventListener('keyup',() => this.reset());
    document.body.addEventListener('keypress',() => this.reset());
  }

  reset() {
    this.lastAction=Date.now();
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {
    const now = Date.now();
    const timeleft = this.lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    if (isTimeout)  {
      localStorage.removeItem('lastAction');
      this.authService.logoutUser();
    }
  }

}
